import Colors from '@dynatrace/strato-design-tokens/colors';

import { SingleValueConfigProperties } from './types/single-value.js';

export const defaultSingleValueConfig: SingleValueConfigProperties = {
  color: Colors.Text.Neutral.Default,
  alignment: 'start',
};

export const SINGLE_VALUE_ARIA_LABEL = 'Single Value';
